export default __webpack_public_path__ + "assets/ico_step_8-343151f4.svg";